import { AttendanceActionTypes } from "./attendance.types";

export const fetchAttendanceStart = (payload: any) => ({
  type: AttendanceActionTypes.FETCH_ATTENDANCE_START,
  payload,
});

export const fetchAttendanceSuccess = (attendanceDetails: any) => ({
  type: AttendanceActionTypes.FETCH_ATTENDANCE_SUCCESS,
  payload: attendanceDetails,
});

export const fetchAttendanceFailure = (error: any) => ({
  type: AttendanceActionTypes.FETCH_ATTENDANCE_FAILURE,
  payload: error,
});

export const fetchAttendanceChanged = () => ({
  type: AttendanceActionTypes.FETCH_ATTENDANCE_CHANGED,
});

export const fetchAttendanceReset = () => ({
  type: AttendanceActionTypes.ATTENDANCE_RESET,
});

// Update Attendance
export const updateAttendanceStart = (payload: any) => ({
  type: AttendanceActionTypes.UPDATE_ATTENDANCE_START,
  payload,
});

export const updateAttendanceSuccess = (attendanceDetails: any) => ({
  type: AttendanceActionTypes.UPDATE_ATTENDANCE_SUCCESS,
  payload: attendanceDetails,
});

export const updateAttendanceFailure = (error: any) => ({
  type: AttendanceActionTypes.UPDATE_ATTENDANCE_FAILURE,
  payload: error,
});

export const updateAttendanceChanged = () => ({
  type: AttendanceActionTypes.UPDATE_ATTENDANCE_CHANGED,
});

export const updateAttendanceReset = () => ({
  type: AttendanceActionTypes.UPDATE_ATTENDANCE_RESET,
});

// Download Attendance
export const fetchAttendanceDownloadDetailsStart = (payload: any) => ({
  type: AttendanceActionTypes.FETCH_ATTENDANCE_DOWNLOAD_DETAILS_START,
  payload,
});

export const fetchAttendanceDownloadDetailsSuccess = (
  attendanceDetails: any,
) => ({
  type: AttendanceActionTypes.FETCH_ATTENDANCE_DOWNLOAD_DETAILS_SUCCESS,
  payload: attendanceDetails,
});

export const fetchAttendanceDownloadDetailsFailure = (error: any) => ({
  type: AttendanceActionTypes.FETCH_ATTENDANCE_DOWNLOAD_DETAILS_FAILURE,
  payload: error,
});

export const fetchAttendanceDownloadDetailsChanged = () => ({
  type: AttendanceActionTypes.FETCH_ATTENDANCE_DOWNLOAD_DETAILS_CHANGED,
});

export const fetchAttendanceDownloadDetailReset = () => ({
  type: AttendanceActionTypes.FETCH_ATTENDANCE_DOWNLOAD_DETAIL_RESET,
});

//*******EXPORT ATTENDANCE PAGE START********* */

export const attendanceExportAllStart = (attendanceList: any) => ({
  type: AttendanceActionTypes.ATTENDANCE_EXPORT_START,
  payload: attendanceList,
});
export const attendanceExportAllSuccess = (success: any) => ({
  type: AttendanceActionTypes.ATTENDANCE_EXPORT_SUCCESS,
  payload: success,
});
export const attendanceExportAllFailure = (failure: any) => ({
  type: AttendanceActionTypes.ATTENDANCE_EXPORT_FAILURE,
  payload: failure,
});
export const attendanceExportAllReset = () => ({
  type: AttendanceActionTypes.ATTENDANCE_EXPORT_CHANGED,
});
export const attendanceExportAllChanged = () => ({
  type: AttendanceActionTypes.ATTENDANCE_EXPORT_RESET_START,
});

//*******EXPORT ATTENDANCE PAGE END********* */
